import React, { createContext, useContext, useState, useEffect } from 'react';

const BannerContext = createContext();

export const BannerProvider = ({ children }) => {
  const [showBanner, setShowBanner] = useState(true);
  const [isAtTop, setIsAtTop] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      setIsAtTop(window.scrollY < 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Auto-hide banner after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBanner(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  // Determine if banner should be visible
  const isBannerVisible = showBanner && isAtTop;

  return (
    <BannerContext.Provider value={{ showBanner: isBannerVisible, setShowBanner, isAtTop }}>
      {children}
    </BannerContext.Provider>
  );
};

export const useBanner = () => {
  const context = useContext(BannerContext);
  if (!context) {
    throw new Error('useBanner must be used within a BannerProvider');
  }
  return context;
};